import Icon from '../components/Icon.vue'

Icon.register({
  'address-card': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M528 32c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-480c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h480zM176 128c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64zM288 364.8v-19.2c0-31.8-30.1-57.6-67.2-57.6h-5c-12.2 5.1-25.7 8-39.8 8s-27.5-2.9-39.8-8h-5c-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2h179.2c12.4 0 22.4-8.6 22.4-19.2zM512 312v-16c0-4.4-3.6-8-8-8h-144c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8zM512 248v-16c0-4.4-3.6-8-8-8h-144c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8zM512 184v-16c0-4.4-3.6-8-8-8h-144c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/address-card.js
// module id = 591
// module chunks = 0